<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully added a new admin!</div>
        </div>
        <b-alert variant="danger"
          dismissible
          :show="failure"
          @dismissed="failure=false">
          {{message}}
        </b-alert>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Add Admin</strong>
          </div>
          <b-form @submit.prevent="addAdmin">
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label>First Name</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="firstName"
                  placeholder="Enter first name of the admin"
                  name="first_name"
                  :class="{'has-error': errors.has('first_name')}"
                ></b-form-input>
                <span class="red">{{ errors.first('first_name') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>Last Name</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="lastName"
                  placeholder="Enter last name of the admin"
                  name="last_name"
                  :class="{'has-error': errors.has('last_name')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('last_name') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label>Email</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="email"
                  name="email"
                  placeholder="Enter the email of the admin"
                  :class="{'has-error': errors.has('email')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('email') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label>Password</label>
                <b-form-input
                  type="password"
                  v-validate="'required'"
                  v-model="password"
                  name="password"
                  placeholder="Enter the password for the admin"
                  :class="{'has-error': errors.has('password')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('email') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="8">
              <b-form-group>
                <label>Level of Access</label>&nbsp;<router-link to="/level-access">See all</router-link>
                <b-form-radio-group
                  id="basicRadiosCustom"
                  value="1"
                  stacked>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio1" class="custom-control-input" v-model="level" value="1" checked>
                    <label class="custom-control-label" for="customRadio1">Level 1 - Main Administrator<br /><span class="text-muted">The person who serves as the primary contact for the account. Has access to everything.</span></label>
                  </div>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio2" class="custom-control-input" v-model="level" value="2">
                    <label class="custom-control-label" for="customRadio2">Level 2 - Department Administrator<br /><span class="text-muted">This is for heads of departments. This user has access to everything except admin creation and personal user information.</span></label>
                  </div>
                  <div class="custom-control custom-radio access-radio">
                    <input type="radio" name="customRadio" id="customRadio3" class="custom-control-input" v-model="level" value="3">
                    <label class="custom-control-label" for="customRadio3">Level 3 - Store Administrator<br /><span class="text-muted">For store owners/managers to view data to their specific store.</span></label>
                  </div>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import getAdmin from '../../mixins/getAdmin'

export default {
  name: 'Add',
  mixins: [
    getAdmin
  ],
  data () {
    return {
      email: '',
      failure: false,
      firstName: '',
      lastName: '',
      level: 1,
      message: '',
      password: '',
      postalCode: '',
      success: false
    }
  },
  methods: {
    /**
     * Submits the form information to the backend API once submit button is pressed. The information is passed through a validator to make sure they meet the required details.
     */
    addAdmin: function () {
      let self = this
      this.success = false
      this.failure = false
      const { firstName, lastName, email, password, level } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post(`${process.env.VUE_APP_API_URL}api/admins`, {
            firstName,
            lastName,
            email,
            password,
            level
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              let data = error.response.data

              if (data.success === false) {
                self.failure = true
                self.message = data.message
              }
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
